import { createFileRoute } from "@tanstack/react-router";
import { ProgressSocialProof } from "@/components/home/ProgressSocialProof/ProgressSocialProof";
import { ProgressPricing } from "@/components/home/ProgressPricing/ProgressPricing";
import { seo } from "@/utilities/seo";

export const Route = createFileRoute("/_home/pricing")({
  component: PricingPage,
  head: () => ({
    meta: [
      { title: "Pricing - ProgressMade.ai" },
      ...seo({
        title: "Pricing - ProgressMade.ai",
        description:
          "Invest in your health transformation. Get personalized guidance and advanced tools to achieve real improvements in your health and fitness.",
        keywords:
          "pricing, health, fitness, wellness, planning, health habits, structure, streaks, 75 hard, Bryan Johnson",
        image: "https://progressmade.ai/meta-image.webp",
        canonical: "https://progressmade.ai/pricing",
      }),
    ],
  }),
});

export function PricingPage() {
  return (
    <>
      <ProgressPricing className="mb-10 md:mb-20 lg:mb-32" />
      <ProgressSocialProof />
    </>
  );
}
